import {
  useContext, useMemo,
} from 'react';
import { ENV } from 'appenv';
import { useSelector } from 'react-redux';

import { EventDatetimeContext } from 'components/EventDatetime';
import { UserSessionContext } from 'components/UserSession';

const useIsEventClosedMemo = () => {
  const { hasEventStarted, hasEventEnded } = useContext(EventDatetimeContext);
  const { userSession, canPerformVisitEventUnrestricted } = useContext(UserSessionContext);
  const authToken = useMemo(() => (userSession || {}).authToken, [userSession]);
  const { features } = useSelector((s: any) => s.eventConfigs);
  const isInternalQA = useMemo(() => features.includes('internalQA'), [features]);

  return useMemo(
    () => (
      !(canPerformVisitEventUnrestricted || isInternalQA || hasEventStarted)
      || hasEventEnded
      || !authToken
    ) && ENV === 'production',
    [authToken, canPerformVisitEventUnrestricted, hasEventEnded, hasEventStarted, isInternalQA],
  );
};

export default useIsEventClosedMemo;
